import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { UpsertHuduAuthConfigInput } from "shared/types/integrations";
import { ApiErrorType } from "shared";
import { sentryLogger } from "utilz";
import {
  disconnectHudu,
  getHuduAuthConfig,
  updateHuduStatus,
  upsertHuduAuthConfig,
} from "controller/api";

export const useUpsertHuduAuthConfig = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: UpsertHuduAuthConfigInput) => upsertHuduAuthConfig(data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["huduAuthConfig"],
      });
      queryClient.invalidateQueries({
        queryKey: ["integrationSources"],
      });
    },
    onError: (error: ApiErrorType) => {
      sentryLogger({
        error: error,
        workflow: "integration",
        functionName: "upsertHuduAuthConfig",
      });
    },
  });
};

export const useGetHuduAuthConfig = () => {
  return useQuery({
    queryKey: ["huduAuthConfig"],
    queryFn: () => getHuduAuthConfig(),
    onError: (error: ApiErrorType) => {
      sentryLogger({
        error: error,
        workflow: "integration",
        functionName: "getHuduAuthConfig",
      });
    },
  });
};

export const useUpdateHuduStatus = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (status: boolean) => updateHuduStatus(status),
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(["integrationSources"]);
      queryClient.invalidateQueries(["huduAuthConfig"]);
    },
    onError: (error: ApiErrorType) => {
      sentryLogger({
        error: error,
        workflow: "integration",
        functionName: "updateHuduStatus",
      });
    },
  });
};

export const useDisconnectHudu = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => disconnectHudu(),
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(["integrationSources"]);
      queryClient.invalidateQueries(["huduAuthConfig"]);
    },
    onError: (error: ApiErrorType) => {
      sentryLogger({
        error: error,
        workflow: "integration",
        functionName: "disconnectHudu",
      });
    },
  });
};
